import { Pipe, PipeTransform } from '@angular/core';
import { MobileTimezoneService } from '../services/mobile-timezone.service';

@Pipe({
  name: 'mobileTimezoneDate',
  standalone: true,
  // Impure so timestamps refresh when the global timezone mode changes
  // without requiring each bound date value to change.
  pure: false
})
export class MobileTimezoneDatePipe implements PipeTransform {
  constructor(private mobileTimezoneService: MobileTimezoneService) {}

  transform(
    value: string | number | Date | null | undefined,
    format = 'medium',
    siteId?: number | null,
    includeSuffix = true
  ): string | null {
    return this.mobileTimezoneService.format(value, format, siteId, includeSuffix);
  }
}
